import React from "react";
import "./CircularLoader.scss";

interface CircularLoaderProps {
  size?: number;
  thickness?: number;
  color?: string;
  trackColor?: string;
  className?: string;
}

const CircularLoader: React.FC<CircularLoaderProps> = ({
  size = 44,
  thickness = 6,
  color = "#2c68ad",
  trackColor = "#d9d9d9",
  className = "",
}) => {
  return (
    <span
      className={`circular-loader ${className}`}
      style={
        {
          "--loader-size": `${size}px`,
          "--loader-thickness": `${thickness}px`,
          "--loader-color": color,
          "--loader-track": trackColor,
        } as React.CSSProperties
      }
      aria-label="Loading"
      role="status"
    />
  );
};

export default CircularLoader;
